export const THEMES = [
  { id: "EHW", label: "EHW" },
  { id: "Nerdforce", label: "Nerdforce" },
  { id: "Classic", label: "Classic" },
];

export function normalizeThemeId(themeId) {
  const value = String(themeId || "").trim();
  return value.length ? value : null;
}
